const { get } = require('lodash');

// Pure capability checks shared by packages/agent and packages/api. They read only the
// user's capabilities array, so the same logic is correct on both the decoded session user
// (frontend) and the loaded Agent record (backend). Agency-scope checks live separately in
// each package because their data shape and semantics differ.
/**
 * @param {{ capabilities?: string[] } | null | undefined} user
 * @param {string} capability
 * @returns {boolean}
 */
export const hasCapability = (user, capability) => get(user, 'capabilities', []).includes(capability);

/**
 * @param {{ capabilities?: string[] } | null | undefined} user
 * @returns {boolean}
 */
export const isSuperAdmin = user => hasCapability(user, 'superadmin');

/**
 * @param {{ capabilities?: string[] } | null | undefined} user
 * @returns {boolean}
 */
export const isContentManager = user => isSuperAdmin(user) || hasCapability(user, 'contentmanager');
